import React from 'react';

/**
 * CCPlayer icon set — clean custom SVG geometry, zero antd (the design bar for
 * this surface). Base set lifted from MediaViewer/components/VideoPlayer.js;
 * CaptionsIcon added for the Theater captions toggle.
 */

export const PlayIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M8 5.14v14.72a1 1 0 001.5.86l11.5-7.36a1 1 0 000-1.72L9.5 4.28A1 1 0 008 5.14z" />
  </svg>
);

export const PauseIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
  </svg>
);

export const VolumeHighIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 5L6 9H2v6h4l5 4V5z" />
    <path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.08" />
  </svg>
);

export const VolumeMuteIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 5L6 9H2v6h4l5 4V5z" />
    <line x1="23" y1="9" x2="17" y2="15" />
    <line x1="17" y1="9" x2="23" y2="15" />
  </svg>
);

export const VolumeLowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 5L6 9H2v6h4l5 4V5z" />
    <path d="M15.54 8.46a5 5 0 010 7.08" />
  </svg>
);

export const FullscreenIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3" />
  </svg>
);

export const FullscreenExitIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 3v3a2 2 0 01-2 2H3m18 0h-3a2 2 0 01-2-2V3m0 18v-3a2 2 0 012-2h3M3 16h3a2 2 0 012 2v3" />
  </svg>
);

export const SeekBackIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.5 3C7.26 3 3 7.26 3 12.5S7.26 22 12.5 22c4.5 0 8.27-3.14 9.24-7.36l-1.93-.51C18.99 17.52 16.05 20 12.5 20 8.36 20 5 16.64 5 12.5S8.36 5 12.5 5c2.07 0 3.93.84 5.29 2.19L14 11h8V3l-2.79 2.79A9.458 9.458 0 0012.5 3z" />
    <text x="12" y="15" textAnchor="middle" fontSize="7" fontWeight="bold">10</text>
  </svg>
);

export const SeekForwardIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.5 3c5.24 0 9.5 4.26 9.5 9.5S16.74 22 11.5 22c-4.5 0-8.27-3.14-9.24-7.36l1.93-.51C5.01 17.52 7.95 20 11.5 20c4.14 0 7.5-3.36 7.5-7.5S15.64 5 11.5 5c-2.07 0-3.93.84-5.29 2.19L10 11H2V3l2.79 2.79A9.458 9.458 0 0111.5 3z" />
    <text x="12" y="15" textAnchor="middle" fontSize="7" fontWeight="bold">10</text>
  </svg>
);

export const CaptionsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M10 10.5a2 2 0 00-3.5 1.5 2 2 0 003.5 1.5M17.5 10.5a2 2 0 00-3.5 1.5 2 2 0 003.5 1.5" />
  </svg>
);
